<template>
  <div class="file-input">

    <div class="subsection first">
      <label v-if="!!label">{{ label + ( isMandatory ? ' *' : '') }}</label>
      <vue-dropzone
        ref="dropzone"
        class="full"
        :dropzoneText="placeholder"
        @file-uploaded="fileUploaded"
        @file-uploading="fileUploading"
      />
    </div>

    <span v-if="isError" id="error-message" class="error inline">
      {{ errorMsg }}
    </span>

  </div>
</template>

<script>

import VueDropzone from '@/components/VueDropzone.vue';

export default {
  name: 'FileInput',
  components: {
    VueDropzone,
  },
  props: {
    label: {
      required: true,
    },
    isMandatory: {
      default: false,
    },
    placeholder: {
      default: 'Drop your file here, up to 10MB',
    },
    fullWidth: {
      default: false,
    },
  },
  computed: {
    isError() {
      return this.errorMsg !== '';
    },
    noFile() {
      return !this.value
        || this.value.length === 0;
    },
    valuesObject() {
      return {
        error: this.isError,
        label: this.label,
        value: this.value,
      };
    },
  },
  created() {
    this.$parent.$on('validate-fields', this.validate);
  },
  data() {
    return {
      value: [],
      errorMsg: '',
    };
  },
  methods: {
    validate() {
      this.errorMsg = '';
console.log('In FileInput.validate')
console.log(this.value);
      if (this.isMandatory && this.noFile) {
        console.log('yes is error')
        this.errorMsg = 'Please upload a file.';
      }

      this.$emit('validated-fields', this.valuesObject);
    },
    fileUploading() {
      // this.disableSubmit = true;
      console.log('in FileInput.fileUploading');
      this.$emit('file-uploading');
    },
    fileUploaded(values) {
      console.log('in FileInput.fileUploaded emit INPUT');
      this.value = values.files;
      this.$emit('input', this.valuesObject);
    },
  },
};
</script>

<style lang="scss" scoped>

label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal;
  line-height: 24px;
}

.full {
  display: inline-block;
  @apply ut-w-full;
  margin-right: 10px;
}

</style>
